module.exports = __webpack_public_path__ + "img/no-access.a9f263e9.png";